module.exports = __webpack_public_path__ + "static/media/intro.42c67f7d.png";